import React from 'react';
import PropTypes from 'prop-types';
import { money } from '../../../../utils/format';
import { flatten } from 'flat';

class AuditDetailsBanking extends React.Component {
    renderEventDetailsTableRow(audits, toExclude, levelKey = [], styleClassNeme = 'none') {
        let keyArr = [...levelKey];
        let keysToConvert = [
            'balanceDelta',
            'balance',
            'withdrawableBalance',
            'operatorBalance',
            'totalAmount',
            'fundsLocked',
            'amount',
            'playableBalance',
            'payout',
            'operatorPayout',
            'totalStake',
            'stakePerLine',
            'operatorStakePerLine',
            'operatorTotalStake',
            'maxBet',
            'potentialReturns',
            'profit',
            'operatorProfit',
            'playableAmount'
        ];

        return Object.keys(audits).map((key) => {
            if (toExclude.includes(key) === false) {

                if (audits[key] !== null && audits[key].constructor === Object) {
                    keyArr.push(key);
                    return this.renderEventDetailsTableRow(audits[key], toExclude, keyArr, styleClassNeme)
                }

                if (audits[key] !== null && audits[key].constructor === Array) {
                    if(audits[key][0] && audits[key][0].constructor === Object) {
                        let flattenData = flatten(audits[key]);
                        return Object.keys(flattenData).map(x => {
                            let lastKey = x.split('.').pop();
                            return (
                                <tr className={styleClassNeme}>
                                    <td>{key.charAt(0).toUpperCase() + key.slice(1) + '.' + x}</td>
                                    <td>{ keysToConvert.includes(lastKey) ? money(flattenData[x]) : String(flattenData[x]) }</td>
                                </tr>
                            )
                        })
                    } else {
                        return (
                            <tr className={styleClassNeme}>
                                <td>{key.charAt(0).toUpperCase() + key.slice(1)}</td>
                                <td>{audits[key].map((audit, keyArr) => JSON.stringify(audit).replace(/"/g, " ") + ( keyArr != audits[key].length-1 ? ', ' : '' )) }</td>
                            </tr>
                        )
                    }
                }

                audits[key] = keysToConvert.includes(key) ? money(audits[key]) : audits[key];

                let renderKey = keyArr.join('.');
                return (
                    <tr className={styleClassNeme} key={key}>
                        { keyArr.length > 0 ?
                            <td>{ renderKey.charAt(0).toUpperCase() + renderKey.slice(1) + '.' + key }</td> :
                            <td>{ key.charAt(0).toUpperCase() + key.slice(1) }</td> }
                        <td>{ (typeof(audits[key]) === 'string' || audits[key] === null) ? audits[key] : JSON.stringify(audits[key]) }</td>
                    </tr>
                )
            }
        })
    }

    renderEventDetailsTable() {
        const {audits, id} = this.props;
        let toExclude = ['body'];

        let eventType = id.split('_');
        let eventArr = eventType[eventType.length - 1].split('-');
        for (let i = 0; i < toExclude.length; i++) {
            if (eventArr[0].includes(toExclude[i].slice(0, 5))) {
                toExclude.splice(i, 1);
            }
        }

        return (
            <table>
                <thead>
                <tr>
                    <td>
                        <strong>
                            {eventArr[0].charAt(0).toUpperCase() + eventArr[0].slice(1) + ' ' + eventArr[1].charAt(0).toUpperCase() + eventArr[1].slice(1) }
                        </strong>
                    </td>
                    <td>
                        <strong>
                            Value
                        </strong>
                    </td>
                </tr>
                </thead>
                <tbody>
                { this.renderEventDetailsTableRow(audits.body, toExclude) }
                <tr>
                    <td></td>
                    <td></td>
                </tr>
                <tr>
                    <td></td>
                    <td></td>
                </tr>
                { this.renderEventDetailsTableRow(audits, toExclude, [] , 'technical-details') }
                </tbody>
            </table>
        )
    }

    render() {
        return (
            <div className="audit-details-bets">
                { this.renderEventDetailsTable() }
            </div>
        );
    }
}

export default AuditDetailsBanking;
